module.exports = __webpack_public_path__ + "static/media/brachypodium_distachyon.whole_plant.9ca35601.svg";